module.exports = __webpack_public_path__ + "static/play-store-38f70255fbc32dbe2655d7d0f1c10ff5.png";